/* global axios */
import ApiClient from '../ApiClient';

class WgptBotKnowledgeManagerAPI extends ApiClient {
  constructor(botId) {
    super(`bots/${botId}/knowledge_manager`, {
      accountScoped: true,
      wgpt: true,
    });
  }

  state() {
    return axios.get(`${this.url}/state`);
  }

  converse(payload) {
    return axios.post(`${this.url}/converse`, payload);
  }

  persist() {
    return axios.patch(`${this.url}/persist`);
  }

  rollback(payload) {
    return axios.patch(`${this.url}/rollback`, payload);
  }

  reset() {
    return axios.delete(`${this.url}/reset`);
  }
}

export default WgptBotKnowledgeManagerAPI;
